import * as types from './actionTypes';  
import deleteOrderApi from '../api/deleteOrderApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';
import { loadingRes } from './loadingActions';

export function doDeleteOrder(request) {

  return {
    type: types.DO_DELETE_ORDER, 
    request
  };
}

export function doDeleteOrderRes(data) {  
  return {
    type: types.DO_DELETE_ORDER_RES, 
    data
  };
}

export function submitDeleteOrder(request) {
  const TOKEN = getItem('auth_token');
  if(TOKEN){
    return function(dispatch) {
      dispatch(loadingRes(true));
      deleteOrderApi.doDeleteOrder(request).then(data => {
        dispatch(doDeleteOrderRes(data));
        dispatch(doDeleteOrderRes(null));
        dispatch(loadingRes(false));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          });
        }
      }).catch(error => {
        dispatch(loadingRes(false));
        return error
      });
    };
  }else{
    logout()
  }
}

